<template>
  <div
    :class="[
      'richtext',
      { 'richtext--checkmark-bullets': useCheckmarkBullets }
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'KfRichText',
  props: {
    useCheckmarkBullets: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="postcss">
.richtext {
  p {
    line-height: theme('lineHeight.xl');
  }

  /* margin bottom for rte elements */
  p,
  ul,
  ol,
  .richtext-download-links,
  .richtext-external-links,
  .richtext-buttons-primary {
    @apply mb-7;
  }

  > :last-child {
    @apply mb-0;
  }

  /* links & buttons */
  .richtext-download-links,
  .richtext-external-links {
    @apply flex flex-col;

    a:not(:last-child) {
      @apply mb-2;
    }
  }

  .richtext-buttons-primary a:not(:last-child) {
    @apply mr-3 mb-2;
  }

  /* lists */
  ul,
  ol {
    @apply ml-5;

    li {
      @apply pl-6;
    }
  }

  ul {
    /* default bullet */
    li:before {
      @apply w-6 -ml-6 text-primary-bravo font-normal inline-block;
      content: "\2022";
    }
  }

  ol {
    @apply list-decimal;
  }
}

/* When useCheckmarkBullets is true… */
.richtext--checkmark-bullets {
  /* remove native bullets */
  ul {
    @apply list-none;
  }

  /* inject checkmark instead */
  ul li:before {
    @apply w-7 -ml-6 text-secondary-charlie font-bold inline-block;
    content: "\2713"; /* ✔ */
  }
}
</style>
